import { getBaseUrl } from '../../maps/apiEnvironmentMap';
import { EntryAvailability } from '../microservices';

const API_KEY = process.env.REACT_APP_API_KEY;
export class EntryAvailabilityRequestPOST {
  readonly method: string = 'operation/entry/availability';
  public buildURL() {
    let baseURL = getBaseUrl('locker');
    return `${baseURL}/${this.method}`;
  }
  public generateContent(pieceNumber: string) {
    const params = {
      pieceNumber: pieceNumber,
    };
    return params;
  }
  public generateConfig(token: string) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'dhl-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    };
  }
}
export type EntryAvailabilityResponsePOST = {
  status: string;
  message: string;
  data: {
    message: string;
    errors: any;
    entryAvailability: EntryAvailability;
  };
};
